<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
  <esl-message-toast [(message)]="error"></esl-message-toast>
</div>
<div class="ui segment content" [ngClass]="{ loading: pending }">
  <form class="ui form" [formGroup]="subtopicForm">
    <div class="field" appMargin marginB="15px">
      <label>Sub-topic </label>
      <div class="ui input">
        <input
          formControlName="subtopic"
          placeholder="Enter sub-topic"
          type="text"
        />
      </div>
    </div>
  </form>

  <div class="actions" style="border: none">
    <button class="ui primary basic button" (click)="modal.deny(undefined)">
      Back
    </button>
    <button
      class="ui primary button"
      [disabled]="pending || !subtopicForm.valid"
      (click)="submit()"
    >
      Add Sub-topic
    </button>
  </div>
</div>
